import { useSelector } from 'react-redux';
import { ACCOUNT_SELLER_STATUS } from '../../../constants/service/app/accountSellerConstants';

export const useIsBrandRequestJoin = () => {
  //redux store에서 브랜드 상태정보 조회
  const statusInfo = useSelector((state) => state.brand.brandDetail.info.statusInfo);

  //브랜드 승인여부 확인
  return statusInfo.status === ACCOUNT_SELLER_STATUS.REQUEST || statusInfo.status === ACCOUNT_SELLER_STATUS.REJECT;
};
